export default "__VITE_ASSET__DSyKaWAk__"